import { useEffect, useMemo, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import { isAdmin } from "../services/userService";

export const useUserIsAdmin = () => {
  const [user, isAuthLoading] = useAuthState(auth);
  const [loading, setLoading] = useState(true);
  const [userIsAdmin, setUserIsAdmin] = useState(false);

  useEffect(() => {
    if (!user) {
      if (!isAuthLoading) {
        setLoading(false);
      }
      return;
    }

    setLoading(true);
    (async () => {
      const adminStatus = await isAdmin(user);
      setUserIsAdmin(adminStatus);
      setLoading(false);
    })();
  }, [user, isAuthLoading]);

  return useMemo(() => {
    return {
      userIsAdmin,
      loading,
      authedUserId: user?.uid,
    };
  }, [userIsAdmin, loading, user]);
};
